import { Address } from '../address';
import { Region } from '../region';
import { Service } from '../service';
import { Profile } from './profile';

export class User {
	id: number;
	username: string;
	email: string;
	password: string;
	profile: Profile;
	active: boolean;
	firstName: string;
	lastName: string;
	status: string;
	address: Address;
	telephone: string;
	birthDate: string;
	typeUser: string;
	services: Service[];
	regions: Region[];
	motDePasseGenere: string;

	constructor(
		options: {
			id?: number;
			username?: string;
			firstName?: string;
			lastName?: string;
			motDePasseGenere?: string;
		} = {}
	) {
		this.id = options.id || 0;
		this.username = options.username || null;
		this.firstName = options.firstName || null;
		this.lastName = options.lastName || null;
		this.motDePasseGenere = options.motDePasseGenere || null;
	}
}
